import * as React from 'react';
import { usePage } from '@inertiajs/react';
import { assetUrl } from '../../utils/assetUrl';

export function WhyUsHero() {
  const { cdnUrl } = usePage<{ cdnUrl: string }>().props;
  const heroImg = assetUrl(cdnUrl, '/img/whyus-hero.webp');

  return (
    <section className="whyus-hero">
      <style>{`
        .whyus-hero {
          position: relative;
          background: url(${heroImg}) center center/cover no-repeat;
          padding: 100px 0 110px;
          min-height: 480px;
          display: flex;
          align-items: center;
        }
        .whyus-hero::before {
          content: '';
          position: absolute;
          inset: 0;
          background: rgba(0, 0, 0, 0.7);
        }
        .whyus-hero-inner {
          position: relative;
          z-index: 1;
          max-width: 800px;
          margin: 0 auto;
          padding: 0 24px;
          text-align: center;
        }
        .whyus-hero h1 {
          font-size: 38px;
          font-weight: 800;
          color: #fff;
          margin: 0 0 16px;
          line-height: 1.2;
        }
        .whyus-hero .hero-accent {
          font-size: 24px;
          font-weight: 600;
          color: #1EAA25;
          margin: 0 0 12px;
        }
        .whyus-hero .hero-desc {
          font-size: 20px;
          color: rgba(255,255,255,0.7);
          margin: 0 0 40px;
          font-weight: 500;
        }
        .whyus-hero-ctas {
          display: flex;
          gap: 16px;
          justify-content: center;
          flex-wrap: wrap;
        }
        .whyus-btn-primary {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 14px 28px;
          background: #1EAA25;
          color: #fff;
          font-size: 16px;
          font-weight: 600;
          border-radius: 8px;
          text-decoration: none;
          transition: background 0.2s;
        }
        .whyus-btn-primary:hover {
          background: #178f1e;
          color: #fff;
          text-decoration: none;
        }
        .whyus-btn-secondary {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 14px 28px;
          background: transparent;
          color: #fff;
          font-size: 16px;
          font-weight: 600;
          border: 2px solid rgba(255,255,255,0.6);
          border-radius: 8px;
          text-decoration: none;
          transition: all 0.2s;
        }
        .whyus-btn-secondary:hover {
          background: rgba(255,255,255,0.1);
          border-color: #fff;
          color: #fff;
          text-decoration: none;
        }
        @media (max-width: 640px) {
          .whyus-hero {
            padding: 70px 0 80px;
            min-height: auto;
          }
          .whyus-hero h1 {
            font-size: 28px;
          }
          .whyus-hero .hero-accent {
            font-size: 19px;
          }
          .whyus-hero .hero-desc {
            font-size: 17px;
          }
          .whyus-hero-ctas {
            flex-direction: column;
            align-items: stretch;
          }
          .whyus-btn-primary, .whyus-btn-secondary {
            justify-content: center;
          }
        }
      `}</style>
      <div className="whyus-hero-inner">
        <h1>No somos una verdulería con página web.</h1>
        <p className="hero-accent">Somos un ecommerce nativo de frutas y verduras.</p>
        <p className="hero-desc">La diferencia es todo.</p>
        <div className="whyus-hero-ctas">
          <a href="/productos" className="whyus-btn-primary">
            <i className="fa fa-shopping-cart" /> Empezá a comprar
          </a>
          <a href="/productos" className="whyus-btn-secondary">
            <i className="fa fa-leaf" /> Conocé nuestros productos
          </a>
        </div>
      </div>
    </section>
  );
}
